export enum FeatureTypes {
  ACCOUNT = 'feature-account',
  LEGACY_APPLICATION = 'legacy-application'
}

export const isFeatureEnable = (feature: FeatureTypes): boolean => {
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get(feature) === 'true';
};
